/* eslint-disable prettier/prettier */
/* eslint-disable */

import { connectReducers } from '../../utils';
import genericReducers from '../genericReducer';
import { IReducers } from '../index';

import { GET_ORGANIZATIONS } from '../../actions/employees';
import { REQUEST, FAILURE, SUCCESS } from '../../actions/utils';

import { ICommonResponse, OrganizationRefItem } from '../../api/types';

export type OrganizationState = ICommonResponse<OrganizationRefItem>;

const initialState: OrganizationState = {
  content: [],
  loading: false,
};
const generic = genericReducers<OrganizationState>();
const organizations: IReducers<OrganizationState> = {
  [GET_ORGANIZATIONS[REQUEST]]: generic.get.request,
  [GET_ORGANIZATIONS[SUCCESS]]: generic.get.success,
  [GET_ORGANIZATIONS[FAILURE]]: generic.get.failure,
};

export default connectReducers(initialState, organizations);
